import type { IconButtonProps } from '@mui/material';

import { styled, IconButton as MuiIconButton } from '@mui/material';

const StyledIconButton = styled(MuiIconButton)(({ theme }) => ({
  '&': {
    borderRadius: '9px',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid',
    borderColor: theme.palette.gray.main,
  },
  '& .MuiTouchRipple-root .MuiTouchRipple-child': {
    borderRadius: '9px',
  },
}));

export const IconButton = (props: IconButtonProps) => (
  <StyledIconButton {...props}>{props.children}</StyledIconButton>
);
